import type { WorkbenchContent } from "./contentSchemas";
import type { WorkbenchCatalogCard, WorkbenchItem } from "./layoutSchemas";
import { WorkbenchMedia, WorkbenchSectionBody } from "./WorkbenchSections";

export function WorkbenchCardSections({ item, catalog, content, timezone }: {
  item: WorkbenchItem;
  catalog: WorkbenchCatalogCard;
  content: WorkbenchContent;
  timezone: string;
}) {
  const sections = content.sections.filter(section => !item.config.hidden_sections.includes(section.key));

  return <div className="workbench-card__sections">
    {content.media && item.card_type === "media_reference" && <WorkbenchMedia key={content.media.public_url} media={content.media} title={content.title} />}
    {sections.map(section => <section key={section.key} className="workbench-section" data-section={section.key} data-section-kind={section.kind} data-section-state={section.state}>
      <h4>{catalog.sections.find(entry => entry.key === section.key)?.label ?? section.key}</h4>
      <WorkbenchSectionBody section={section} timezone={timezone} />
    </section>)}
  </div>;
}
